module.exports = __webpack_public_path__ + "static/img/social-image.dad8da5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-image.jpg
// module id = BBBl
// module chunks = 0